import * as types from './types';

const initialState = {
  collaborators: [],
  errorCollaborators: false,
  hasCollaboratorsInfo: false,
  posting: {},
  loadingPosting: false,
  postingError: false,
  updatingPermissions: false,
  updatedPermission: false,
  errorUpdatePermission: false,
  currentUser: ''
};

function collaboratorsInfoReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_COLLABORATORS_INFO:
      return {
        ...state,
        errorCollaborators: false,
        loadingCollaborators: true,
        updatedPermission: false
      };
    case types.FETCH_COLLABORATORS_INFO_COMPLETED:
      return {
        ...state,
        collaborators: action.payload,
        loadingCollaborators: false,
        hasCollaboratorsInfo: true
      };
    case types.FETCH_COLLABORATORS_INFO_FAILED:
      return {
        ...state,
        errorCollaborators: true,
        loadingCollaborators: false
      };

    case types.GET_POSTING_INFO:
      return {
        ...state,
        postingError: false,
        loadingPosting: true
      };
    case types.GET_POSTING_INFO_COMPLETED:
      return {
        ...state,
        posting: action.payload,
        loadingPosting: false
      };
    case types.GET_POSTING_INFO_FAILED:
      return {
        ...state,
        postingError: true,
        loadingPosting: false
      };

    case types.UPDATE_USER_PERMISSIONS:
      return {
        ...state,
        updatingPermissions: true,
        updatedPermission: false
      };
    case types.UPDATE_USER_PERMISSIONS_COMPLETED:
      return {
        ...state,
        updatedPermission: true,
        updatingPermissions: false,
        errorUpdatePermission: false,
        currentUser: { name: action.meta.userName, isResponsible: action.meta.query.grant }
      };
    case types.UPDATE_USER_PERMISSIONS_FAILED:
      return {
        ...state,
        errorUpdatePermission: true,
        updatingPermissions: false,
        updatedPermission: false
      };

    default:
      return state;
  }
}

export { collaboratorsInfoReducer };
